import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export default function Tagline({ text }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });

  return (
    <div ref={ref} className="py-4 sm:py-6" data-testid="tagline">
      <motion.div
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 1.5 }}
        className="max-w-3xl mx-auto px-6 text-center"
      >
        <p className="font-serif text-lg sm:text-xl lg:text-2xl italic text-[#C5A059]/40 leading-relaxed tracking-tight">
          {text}
        </p>
      </motion.div>
    </div>
  );
}
